export const COLORS = {
  accent: "#F1520E",
  dark: "#161315",
  light: "#fff9ed",
  semiDark: "#212121",
};
